
export default {
  meta: {
    query: {
      client: 'eshop',
      type: 'taxon'
    }
  }
}
